import React, { useState ,useEffect } from "react"
import { Col, Modal, ModalHeader, ModalBody, ModalFooter, Row, } from "reactstrap"
import CompoundService from "services/Admin/CompoundService"
import SelectOptions from "components/SelectOptions"

const initialFormData = {
    compound_ids: null
}

const FilterModal = ({ modal, toggle, onSumbit ,filterData }) => {

    const [formData, setFormData] = useState(initialFormData)
    const [compoundOptions, setCompoundOptions] = useState([])

    useEffect(() => {
      if (filterData ?.compound_ids ?.length) {
        setFormData((state)=>({ ...state, compound_ids: [...filterData.compound_ids] }))
      }else{
        setFormData((state)=>({ ...state, compound_ids: null }))
  
      }
  }, [])
    return (
        <Modal isOpen={modal} toggle={toggle}
            className="rightModalSide scrollbar-container mt-0">
            <ModalHeader toggle={toggle}>
                Unit Filters
            </ModalHeader>
            <ModalBody>
                <Col md={12}>
                    <SelectOptions
                        label='Compound'
                        placeholder='Select'
                        options={compoundOptions}
                        handleSelectChange={data => setFormData({ ...formData, compound_ids: data })}
                        selectedOption={formData.compound_ids}
                        Service={CompoundService}
                        setOptions={options => setCompoundOptions(options)}
                        isMulti={true}

                    />
                </Col>
            </ModalBody>
            <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                <button
                    type='button'
                    className='btn btn-light w-120'
                    onClick={() => {
                        setFormData(initialFormData)
                        onSumbit(initialFormData)
                    }}
                >
                    Reset Filter
                       </button>
                <button type='button'
                    onClick={() => {
                        onSumbit(formData)
                        toggle()
                    }}
                    className='btn btn-success  w-120'>
                    Apply Filter
                    </button>
            </ModalFooter>
        </Modal>
    )
}
export default FilterModal